// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__bXRHy","footer":"ModalFilter_footer__31jrj"};